import { render, staticRenderFns } from "./MarketplaceIdTemplate.vue?vue&type=template&id=90bfbec6&scoped=true&"
import script from "./MarketplaceIdTemplate.vue?vue&type=script&lang=js&"
export * from "./MarketplaceIdTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bfbec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90bfbec6')) {
      api.createRecord('90bfbec6', component.options)
    } else {
      api.reload('90bfbec6', component.options)
    }
    module.hot.accept("./MarketplaceIdTemplate.vue?vue&type=template&id=90bfbec6&scoped=true&", function () {
      api.rerender('90bfbec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/MarketplaceIdTemplate.vue"
export default component.exports